<template>
  <LayoutActionCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    @delete="$emit('delete')"
    @configure="handleConfigure"
  >
    <template #icon>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z" fill="#FFFFFF"/>
      </svg>
    </template>

    <template #content>
      <!-- Not Configured State -->
      <div v-if="!isConfigured" class="action-content">
        <!-- Info Message -->
        <!-- <div class="info-message">
          <img src="@/assets/MyWorkBench/Workflow/information_icon_circle.svg" style="width: 20px; height: 20px; margin-right: 4px;" />
          <span class="info-text">Choose or upload documents in the editor panel on the right.</span>
        </div> -->
              </div>

      <!-- Configured State -->
      <div v-else class="action-content action-content--configured">
        <div class="document-count">{{ documentCount }}</div>
        <div class="document-list">
          <span class="document-label">Documents: </span>
          <span class="document-names">{{ displayDocuments }}</span>
        </div>
              </div>
    </template>
  </LayoutActionCard>
</template>

<script>
import LayoutActionCard from './LayoutActionCard.vue';

export default {
  name: 'SendDocuments',
  components: {
    LayoutActionCard
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'configure'],
  data() {
    return {
      localFormData: {
        documents: this.data.documents || []
      }
    };
  },
  computed: {
    title() {
      return 'Send Documents';
    },
    subtitle() {
      return 'Send selected documents to the patient';
    },
    // Use savedData for display when available
    displayData() {
      console.log('displayData', this.data);
      return this.data;
    },
    isConfigured() {
      return Boolean(this.displayData && this.displayData.configured);
    },
    isConfigureActive() {
      // Configure is active when documents are selected
      const selectedDocs = this.localFormData.documents.filter(doc => doc.selected);
      return Boolean(selectedDocs && selectedDocs.length > 0);
    },
    documentCount() {
      if (this.displayData && this.displayData.documents && this.displayData.documents.length > 0) {
        const count = this.displayData.documents.length;
        return `${count} document${count !== 1 ? 's' : ''} selected`;
      }
      return '0 documents selected';
    },
    displayDocuments() {
      if (this.displayData && this.displayData.documents && this.displayData.documents.length > 0) {
        const selectedDocs = this.displayData.documents
        if (selectedDocs.length > 0) {
          return selectedDocs.map(doc => doc.name).join('; ');
        }
      }
      return 'N/A';
    }
  },
  watch: {
    'data.documents': {
      handler(newVal) {
        if (newVal && JSON.stringify(newVal) !== JSON.stringify(this.localFormData.documents)) {
          this.localFormData.documents = newVal;
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // Initialize local form data from props if available
    if (this.data && this.data.documents) {
      this.localFormData.documents = this.data.documents;
    }
  },
  methods: {
    handleConfigure() {
      this.$emit('configure', {
        documents: this.localFormData.documents
      });
    },
    updateSharedData() {
      this.data.documents = this.localFormData.documents;
    }
  }
};
</script>

<style scoped>
.action-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.action-content--configured {
  gap: 8px;
}

/* Info Message */
.info-message {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 4px 0;
}

.info-text {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

/* Configured State */
.document-count {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

.document-list {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-label {
  font-weight: 700;
  color: #374957;
}

.document-names {
  font-weight: 400;
  color: #333;
}

</style>
